import { STORY_WALK_SHEET } from '@rdd/content/story'
import type { StoryDirection } from '@rdd/contracts'

/**
 * Como o mundo se ve (modo_historia_mundos/03#HM-002). docs/21 secao 6, ADR 0062. Logica pura: a cena le
 * daqui o quadro da caminhada e a transparencia da copa, e o teste exercita sem canvas.
 */

/** A altura do personagem, em tiles, do pe ao topo da cabeca: a escala da folha sai dela. */
export const AVATAR_HEIGHT_TILES = 3

/** Quanto se anda, em tiles, por quadro da caminhada: 8 quadros a cada 2 tiles, um ciclo de dois passos. */
const STRIDE_TILES = 0.25

/** A escala da folha de caminhada para o personagem ter `AVATAR_HEIGHT_TILES` no mapa. */
export const walkSheetScale = (tilePixels: number): number =>
  (AVATAR_HEIGHT_TILES * tilePixels) / STORY_WALK_SHEET.baseline

/**
 * O quadro da caminhada pela DISTANCIA andada, e nao pelo tempo (docs/21 secao 6): o pe acompanha o chao em
 * qualquer velocidade, inclusive na interpolacao de rede. Parado, o primeiro quadro.
 */
export function walkFrame(walkedPixels: number, tilePixels: number, moving: boolean): number {
  if (!moving) return 0
  return Math.floor(walkedPixels / (STRIDE_TILES * tilePixels)) % STORY_WALK_SHEET.frames
}

/** A linha da folha de cada direcao. */
export const sheetRow = (facing: StoryDirection): number => STORY_WALK_SHEET.rows.indexOf(facing)

/** O retangulo de um prop no mundo, em pixels, e a linha do chao que decide quem passa na frente. */
export type PropBox = { x: number; y: number; width: number; height: number; depth: number }

/** Um prop so esconde alguem se for alto: o arbusto nao fica translucido, a arvore sim. */
const TALL_PROP_TILES = 1.5

/** A transparencia da copa com alguem atras, como no IDLE FORCE. */
export const CANOPY_ALPHA = 0.45

/**
 * O pe de alguem esta ATRAS do prop? Esta, se ele fica acima da linha do chao do prop, dentro do retangulo
 * desenhado -- e o prop e alto o bastante para tapar uma pessoa.
 */
export function hiddenBehind(feet: { x: number; y: number }, prop: PropBox, tilePixels: number): boolean {
  if (prop.height < TALL_PROP_TILES * tilePixels) return false
  return feet.y < prop.depth && feet.y > prop.y && feet.x > prop.x && feet.x < prop.x + prop.width
}

/** Aproxima um valor do alvo a cada quadro: a copa some e volta suave. */
export const approach = (current: number, target: number, rate = 0.15): number =>
  Math.abs(target - current) < 0.01 ? target : current + (target - current) * rate
